<template>
  <section
    class="bg-white sm:text-left shadow-xl rounded-xl sm:w-full sm:p-10 sm:h-full p-5"
  >
    <h3 class="sm:text-xl font-bold text-base">
      {{ title }}
    </h3>
    <h5 v-if="subtitle" class="sm:text-sm text-sm text-left">
      {{ subtitle }}
    </h5>
    <apexchart
      :id="idChart"
      type="bar"
      height="90%"
      width="100%"
      :options="chartOptions"
      :series="series"
      class="mt-6"
    ></apexchart>
  </section>
</template>
<script>
import {
  STATE_SFC_PENDIENTE_GESTION,
  STATE_SFC_CONTRAPROPUESTA_EV,
  STATE_SFC_SESION_CHAT_PROGRAMADA,
  STATE_SFC_CERRADA_CONTRAPROPUESTA_ACEPTADA,
  STATE_SFC_CERRADA_DESISTIMIENTO,
  STATE_SFC_CERRADA_INACTIVIDAD_CF,
} from "@/core/utils/constants";
import apexChartResizeFix from "@/mixins/apexChartResizeFix";
export default {
  mixins: [apexChartResizeFix],
  props: {
    chartColors: {
      type: Array,
      default: () => undefined,
    },
    title: {
      type: String,
      default: "Total de Quejas por Producto",
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    favorableData: {
      type: [],
    },
    parcialyFavorableData: {
      type: [],
    },
    noFavorableData: {
      type: [],
    },
    stateSfcPendienteGestionData: {
      type: [],
    },
    stateSfcContrapropuestaEvData: {
      type: [],
    },

    stateSfcSesionChatProgramadaData: {
      type: [],
    },

    stateSfcCerradaContrapropuestaAceptadaData: {
      type: [],
    },

    stateSfcCerradaDesistimientoData: {
      type: [],
    },
    stateSfcCerradaInactividadCfData: {
      type: [],
    },
    datax: {
      type: [],
    },
    idChart: {
      type: String,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          redrawOnParentResize: true,
          stacked: true,
          height: "90%",
          width: "100%",
        },
        noData: {
          text: "No hay datos para graficar",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "24px",
            fontFamily: undefined,
          },
        },
        plotOptions: {
          bar: {
            horizontal: undefined,
            borderRadius: 0,
            columnWidth: "50%",
            dataLabels: {
              position: "center",
            },
          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "13px",
            colors: ["#fff"],
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
          fontSize: "14px",
          itemMargin: {
            horizontal: 20,
            vertical: 5,
          },
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              xaxis: {
                labels: {
                  style: {
                    fontSize: "7px",
                  },
                },
              },
              plotOptions: {
                bar: {
                  borderRadius: 0,
                },
              },
            },
          },
          {
            breakpoint: 300,
            options: {
              chart: {
                height: "100%",
                width: "100%",
                zoom: {
                  enabled: false,
                },
              },
              plotOptions: {
                bar: {
                  borderRadius: 0,
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "7px",
                  },
                },
              },
              yaxis: [
                {
                  title: {
                    text: "",
                  },
                },
                {
                  opposite: true,
                  title: {
                    text: "",
                  },
                },
              ],
            },
          },
        ],
        theme: {
          monochrome: {
            enabled: true,
            color: "#004884",
          },
        },
      },
    };
  },
  watch: {
    datax: { handler: "buildChartData", deep: true },
    stateSfcPendienteGestionData: { handler: "buildChartData", deep: true },
    stateSfcContrapropuestaEvData: { handler: "buildChartData", deep: true },
    stateSfcSesionChatProgramadaData: { handler: "buildChartData", deep: true },
    stateSfcCerradaContrapropuestaAceptadaData: {
      handler: "buildChartData",
      deep: true,
    },
    stateSfcCerradaDesistimientoData: { handler: "buildChartData", deep: true },
    stateSfcCerradaInactividadCfData: { handler: "buildChartData", deep: true },
    chartColors: { handler: "buildChartData", deep: true },
  },
  created() {
    this.buildChartData();
  },
  methods: {
    processSeries(serie) {
      const copy = Array.isArray(serie) ? [...serie] : [];
      const mod = (this.datax && this.datax.length) - copy.length;
      for (let index = 0; index < mod; index++) {
        copy.push(0);
      }
      return copy;
    },
    buildChartData() {
      const datax = this.datax || [];
      this.series = [
        {
          name: STATE_SFC_PENDIENTE_GESTION,
          data: this.processSeries(this.stateSfcPendienteGestionData),
        },
        {
          name: STATE_SFC_CONTRAPROPUESTA_EV,
          data: this.processSeries(this.stateSfcContrapropuestaEvData),
        },
        {
          name: STATE_SFC_SESION_CHAT_PROGRAMADA,
          data: this.processSeries(this.stateSfcSesionChatProgramadaData),
        },
        {
          name: STATE_SFC_CERRADA_CONTRAPROPUESTA_ACEPTADA,
          data: this.processSeries(
            this.stateSfcCerradaContrapropuestaAceptadaData,
          ),
        },
        {
          name: STATE_SFC_CERRADA_DESISTIMIENTO,
          data: this.processSeries(this.stateSfcCerradaDesistimientoData),
        },
        {
          name: STATE_SFC_CERRADA_INACTIVIDAD_CF,
          data: this.processSeries(this.stateSfcCerradaInactividadCfData),
        },
      ];
      this.chartOptions.plotOptions.bar.horizontal = this.horizontal;
      this.chartOptions.xaxis.categories = [...datax];
      this.chartOptions.dataLabels.offsetX = 0;
      this.chartOptions.dataLabels.offsetY = 0;
      const useCustomColors =
        this.chartColors &&
        Array.isArray(this.chartColors) &&
        this.chartColors.length > 0;
      this.chartOptions.colors = useCustomColors ? this.chartColors : undefined;
      this.chartOptions.theme.monochrome.enabled = !useCustomColors;
    },
  },
};
</script>
